import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/app/apps/fe-news/components/atoms/RwdAdSlot/RwdAdSlot.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/app/apps/fe-news/components/molecules/NewsCoverImage/NewsCoverImage.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/app/apps/fe-news/components/molecules/NewsCoverVideo/NewsCoverVideo.tsx");
;
import(/* webpackMode: "eager" */ "/opt/app/apps/fe-news/components/organisms/NewsCoverImageOrVideo/NewsCoverImageOrVideo.linaria.module.css");
;
import(/* webpackMode: "eager" */ "/opt/app/apps/fe-news/components/NewsDetail/NewsContent.linaria.module.css");
;
import(/* webpackMode: "eager" */ "/opt/app/apps/fe-news/app/(print)/news/print/[id]/page.linaria.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/app/apps/fe-news/components/PrintEffect/PrintEffect.tsx");
